import handleError from '@fuse/core/errorHandler';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'app/configs/api';
import axios from 'axios';
const initialState = {
  employeesTodayBirthdays: [],
  employeesUpcomingBirthdays: [],
  topsTodayBirthdays: [],
  topsUpcomingBirthdays: [],
  loading: false,
};

export const getEmployeesTodayBirthdays = createAsyncThunk(
  'birthdays/getEmployeesTodayBirthdays',
  async (body) => {
    try {
      const response = await axios.get(API.getEmployeesTodayBirthdays, body, {
        headers: {
          'Accept-Language': `${localStorage.getItem('language') === 'ru' ? 'ru' : 'uz'}`,
        },
      });
      return response.data;
    } catch (e) {
      handleError(e);
      return [];
    }
  }
);

export const getEmployeesUpcomingBirthdays = createAsyncThunk(
  'birthdays/getEmployeesUpcomingBirthdays',
  async (body) => {
    try {
      const response = await axios.get(API.getEmployeesUpcomingBirthdays, body, {
        headers: {
          'Accept-Language': `${localStorage.getItem('language') === 'ru' ? 'ru' : 'uz'}`,
        },
      });
      return response.data;
    } catch (e) {
      handleError(e);
      return [];
    }
  }
);

const birthdaysSlice = createSlice({
  name: 'birthdays',
  initialState,
  reducers: {},
  extraReducers: {
    [getEmployeesTodayBirthdays.fulfilled]: (state, action) => {
      state.employeesTodayBirthdays = action.payload?.filter((empl) => !empl.isTopManager) || [];
      state.topsTodayBirthdays = action.payload?.filter((empl) => empl.isTopManager) || [];
      state.loading = false;
    },
    [getEmployeesTodayBirthdays.pending]: (state, action) => {
      state.loading = true;
    },
    [getEmployeesTodayBirthdays.rejected]: (state, action) => {
      state.loading = false;
      state.employeesTodayBirthdays = [];
      state.topsTodayBirthdays = [];
    },

    [getEmployeesUpcomingBirthdays.fulfilled]: (state, action) => {
      state.employeesUpcomingBirthdays = action.payload?.filter((empl) => !empl.isTopManager) || [];
      state.topsUpcomingBirthdays = action.payload?.filter((empl) => empl.isTopManager) || [];
      state.loading = false;
    },
    [getEmployeesUpcomingBirthdays.pending]: (state, action) => {
      state.loading = true;
    },
    [getEmployeesUpcomingBirthdays.rejected]: (state, action) => {
      state.loading = false;
      state.employeesUpcomingBirthdays = [];
      state.topsUpcomingBirthdays = [];
    },
  },
});

export const selectEmployeesTodayBirthdays = ({ birthdaysSlice }) =>
  birthdaysSlice.employeesTodayBirthdays;

export const selectEmployeesUpcomingBirthdays = ({ birthdaysSlice }) =>
  birthdaysSlice.employeesUpcomingBirthdays;

export const selectTopsTodayBirthdays = ({ birthdaysSlice }) => birthdaysSlice.topsTodayBirthdays;

export const selectTopsUpcomingBirthdays = ({ birthdaysSlice }) =>
  birthdaysSlice.topsUpcomingBirthdays;

export const selectAreBirthdaysLoading = ({ birthdaysSlice }) => birthdaysSlice.loading;

export default birthdaysSlice.reducer;
